export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7071.e3fa1701.jpg";